import { render, staticRenderFns } from "./ContractsKanban.vue?vue&type=template&id=2a2ff229&"
import script from "./ContractsKanban.vue?vue&type=script&lang=js&"
export * from "./ContractsKanban.vue?vue&type=script&lang=js&"
import style0 from "./ContractsKanban.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports